import React from 'react';
import { Helmet } from 'react-helmet-async';

const GoogleAnalytics = ({ measurementId = "G-XXXXXXXXXX" }) => {
  // 只在生產環境載入GA
  const isProduction = process.env.NODE_ENV === 'production';
  
  if (!isProduction || !measurementId || measurementId === "G-XXXXXXXXXX") {
    return null;
  }

  return (
    <Helmet>
      {/* Google Analytics 4 */}
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', {
            page_title: document.title,
            page_location: window.location.href
          });
        `}
      </script>
    </Helmet>
  );
};

// GA事件追蹤函數
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// 追蹤頁面瀏覽
export const trackPageView = (pagePath, pageTitle, measurementId) => {
  if (typeof window !== 'undefined' && window.gtag && measurementId) {
    window.gtag('config', measurementId, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

// 追蹤聯絡表單送出
export const trackContactForm = (formData) => {
  trackEvent('contact_form_submit', {
    event_category: 'engagement',
    event_label: 'contact_form',
    value: 1
  });
};

// 追蹤作品圖片點擊
export const trackProjectImageClick = (projectType, imageIndex) => {
  trackEvent('project_image_click', {
    event_category: 'engagement',
    event_label: projectType,
    value: imageIndex
  });
};

// 追蹤服務項目點擊
export const trackServiceClick = (serviceName) => {
  trackEvent('service_click', {
    event_category: 'engagement',
    event_label: serviceName,
    value: 1
  });
};

export default GoogleAnalytics; 